export const DISCOUNT_IMAGE =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7e68dcd4f8ea6eb60af1751746fbb9a0-1764238866949/30_%20back%20bomba%20img%20%281%29.png';
